export const scrollElementIntoView = (element) => {
    if (!element) {
        return;
    }
    const elementRect = element.getBoundingClientRect();
    let pos = -(document.body.getBoundingClientRect().top - elementRect.top);
    let subMenuHeight = 0;
    const subMenu = document.querySelector('header .c-menu__item.is-active .c-menu__submenu.level-2');
    if (subMenu && subMenu.getBoundingClientRect().x === 0) {
        subMenuHeight = subMenu.getBoundingClientRect().height;
        pos -= subMenuHeight;
    }
    const header = document.getElementsByTagName('HEADER')[0];
    if (header && elementRect.top < subMenuHeight) {
        pos -= header.getBoundingClientRect().height;
    }
    window.scrollTo(0, pos);
};
export const getUrlParameter = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
};
export const getAnyUrlParameter = (keys) => {
    const urlParams = new URLSearchParams(window.location.search);
    for (const key of keys) {
        if (urlParams.has(key)) {
            return urlParams.get(key);
        }
    }
    return null;
};
